import React from 'react'

import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import * as savePointSelector from '../../SavePoint/savePoint.selectors'

import SurveyViewer from '../../Survey/SurveyViewer'
import EndGameRanking from './EndGameRanking'

class EndGameScreen extends React.Component {
  constructor(props) {
    super(props)
  }

  closeScreen() {
    const { removeScreen } = this.props
    removeScreen('end_game')
  }

  render() {
    const { survey } = this.props
    return (
      <div className="container background background--mars">
        {survey || survey == undefined ? <EndGameRanking /> : <SurveyViewer />}
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    survey: savePointSelector.isSurveyCompleted(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  }
}
EndGameScreen.propTypes = {
  removeScreen: PropTypes.func,
  survey: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EndGameScreen))
